/**
 * Local/Morgan stacks do not have region-separated cells, even when the UI is
 * served from a packaged build rather than the Vite dev server.
 */
const HYPERFABRIC_DOMAIN = "hyperfabric.cisco.com";

const isHyperfabricDeploymentHost = (hostname: string): boolean => {
  const normalizedHostname = hostname.toLowerCase();
  return (
    normalizedHostname === HYPERFABRIC_DOMAIN ||
    normalizedHostname.endsWith(`.${HYPERFABRIC_DOMAIN}`)
  );
};

export const shouldUseUnspecifiedOrgGeo = (): boolean =>
  __APP_VERSION__ === "DEV" ||
  !isHyperfabricDeploymentHost(window.location.hostname);
